import { render } from "./UsefulCards.vue?vue&type=template&id=793dff8c"
import script from "./UsefulCards.vue?vue&type=script&lang=js"
export * from "./UsefulCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__